module.exports = __webpack_public_path__ + "img/success.4c0142c0.png";